import { useMemo } from 'react';
import { useIsFreePortal } from '../../v2/hooks/inventory/useProductInventory';
import { useHasAnySuiteBundlesInProductDetails } from '../../v2/hooks/product/useProductDetails';
import { isValidApiName } from '../../v2/utils/typeguards';
const UPSELL_STARTER_API_NAME = 'crm-suite-starter-bundle';
export const useShowStarterCustomerPlatformUpsellCard = selectedTab => {
  const {
    hasAnySuiteBundles: isTBEligible,
    loading: isTBEligibleLoading
  } = useHasAnySuiteBundlesInProductDetails();
  const {
    isFreePortal: isFreeOrPublic,
    loading: isFreeOrPublicLoading
  } = useIsFreePortal();
  const isEnterpriseTab = selectedTab === 'enterprise';
  const showStarterCustomerPlatformUpsellCard = useMemo(() => {
    return isFreeOrPublic && isTBEligible && !isEnterpriseTab;
  }, [isFreeOrPublic, isTBEligible, isEnterpriseTab]);
  return {
    loading: isFreeOrPublicLoading || isTBEligibleLoading,
    showStarterCustomerPlatformUpsellCard,
    upsellStarterApiName: UPSELL_STARTER_API_NAME
  };
};
export const overrideStarterApiNames = (apiNames, showUpsell, upsellStarterApiName = UPSELL_STARTER_API_NAME) => {
  if (!showUpsell) return apiNames;
  return apiNames.filter(isValidApiName).map(name => name.endsWith('-starter') ? upsellStarterApiName : name);
};